import { useState } from "react";
import { Link } from "react-router-dom";
import logoText from "./logo_text.png"; 
import hamburgerIcon from "../../assets/hamburger-icon.png";
import styles from  "./Header.module.css"; 

export default function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    return(
    <header className={styles.header}>
        <nav className={styles.nav}>
            <div className={styles.logo}>
                <Link to="/" onClick={closeMenu}>
                    <img src={logoText} alt="logo" />
                </Link>
            </div>
            
            {/* Hamburger Button */}
            <button 
                className={`${styles.hamburger} ${isMenuOpen ? styles.hamburgerOpen : ''}`}
                onClick={toggleMenu}
                aria-label="Toggle navigation menu"
            >
                <span className={styles.hamburgerLine}></span>
                <span className={styles.hamburgerLine}></span>
                <span className={styles.hamburgerLine}></span>
            </button>

            {/* Navigation Links */}
            <ul className={`${styles.links} ${isMenuOpen ? styles.linksOpen : ''}`}>
                <li>
                    <Link to="/" onClick={closeMenu} >Strona Główna</Link>
                </li>
                <li>
                    <Link to="/o-mnie" onClick={closeMenu}>O mnie</Link>
                </li>
                <li>
                    <Link to="/kontakt" onClick={closeMenu}>Kontakt</Link>
                </li>
                <li>
                    <Link to="/oferta" onClick={closeMenu}>Oferta</Link>
                </li>
            </ul>

            {/* Overlay for mobile menu */}
            {isMenuOpen && <div className={styles.overlay} onClick={closeMenu}></div>}
        </nav>
    </header>
    )
}